<template>
    <div id="hello">
        <div id="render-wrapper">
            <Render v-bind:isDay="isDay"></Render>
            <button v-on:click="isDay = !isDay" id="toggle-day-night" class="button">Front / Tył</button>
        </div>
        <div id="content"  style="padding-bottom: 4em;">
            <h1 id="main-title">
GALERIA
            </h1>


            <section class="section">
                <div class="container  is-fluid">
                    <div class="columns">
                        <div class="column is-full gallery-wrapper">
                            <h2>WIZUALIZACJE</h2>
        <GalleryComponent />
        <ThreedComponent />

        <p class="small" style="text-align: center; margin-top: 50px;">Budynek znajdujący na wizualizacjach obok prezentowanej inwestycji istnieje - nie jest to kolejny etap przedsięwzięcia deweloperskiego</p>

                        </div>
                    </div>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
    import GalleryComponent from '@/components/GalleryCoolbox.vue';
    import ThreedComponent from '@/components/3dCoolbox.vue';
    import Render from "../components/Render";


    export default {
        name: 'Gallery',
        data() {
            return {
                isDay: true,
            }
        },

    methods: {
        redirect(route) {
            this.$router.push(route);
        }
    },

        components: {
            GalleryComponent,
            ThreedComponent,
            Render
        },
    }
</script>

